import React from "react";

import {DsReturnBar, useDsReturnTarget} from "@/components/DsKit";

function Page(props) {
	const {children, className, freeHeight = false} = props;
	const dsReturn = useDsReturnTarget();

	return (
		<div className="page-content">
			<div
				className={
					"page-body" +
					(className ? " " + className : "") +
					(dsReturn ? " has-ds-return" : "")
				}
			>
				<DsReturnBar target={dsReturn} />
				<div className={"page-children" + (freeHeight ? " free-height" : "")}>
					{children}
				</div>
			</div>
		</div>
	);
}

export default Page;
